'use strict';

import { Entity } from '../Entity';

export class IndDependent extends Entity {
  protected dependentId;

  protected ind;

  protected dependentFirstname;

  protected dependentMiddle;

  protected dependentLastname;

  protected dependentDob;

  protected dependentSocial;

  protected dependentGender;

  protected dependentRelation;

  protected dependentEmail;

  protected dependentPhone;

  protected dependentNote;

  protected dependentResident;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.dependentId = data.dependentId;

    this.ind = data.ind;

    this.dependentFirstname = data.dependentFirstname;

    this.dependentMiddle = data.dependentMiddle;

    this.dependentLastname = data.dependentLastname;

    this.dependentSocial = data.dependentSocial;

    this.dependentGender = data.dependentGender;

    this.dependentRelation = data.dependentRelation;

    this.dependentEmail = data.dependentEmail;

    this.dependentPhone = data.dependentPhone;

    this.dependentNote = data.dependentNote;

    this.dependentResident = data.dependentResident;

    if (data.dependentDob && data.dependentDob != '') {
      const dependentDob = data.dependentDob.date.split(' ')[0].split('-');
      this.dependentDob = dependentDob[1] + '/' + dependentDob[2] + '/' + dependentDob[0];
    }
  }

  public getDependentId() {
    return this.dependentId;
  }

  public setDependentId(dependentId) {
    this.dependentId = dependentId;

    return this;
  }

  public getInd() {
    return this.ind;
  }

  public setInd(ind) {
    this.ind = ind;

    return this;
  }

  public getDependentFirstname() {
    return this.dependentFirstname;
  }

  public setDependentFirstname(dependentFirstname) {
    this.dependentFirstname = dependentFirstname;

    return this;
  }

  public getDependentMiddle() {
    return this.dependentMiddle;
  }

  public setDependentMiddle(dependentMiddle) {
    this.dependentMiddle = dependentMiddle;

    return this;
  }

  public getDependentLastname() {
    return this.dependentLastname;
  }

  public setDependentLastname(dependentLastname) {
    this.dependentLastname = dependentLastname;

    return this;
  }

  public getDependentDob() {
    return this.dependentDob;
  }

  public setDependentDob(dependentDob) {
    this.dependentDob = dependentDob;

    return this;
  }

  public getDependentSocial() {
    return this.dependentSocial;
  }

  public setDependentSocial(dependentSocial) {
    this.dependentSocial = dependentSocial;

    return this;
  }

  public getDependentGender() {
    return this.dependentGender;
  }

  public setDependentGender(dependentGender) {
    this.dependentGender = dependentGender;

    return this;
  }

  public getDependentRelation() {
    return this.dependentRelation;
  }

  public setDependentRelation(dependentRelation) {
    this.dependentRelation = dependentRelation;

    return this;
  }

  public getDependentEmail() {
    return this.dependentEmail;
  }

  public setDependentEmail(dependentEmail) {
    this.dependentEmail = dependentEmail;

    return this;
  }

  public getDependentPhone() {
    return this.dependentPhone;
  }

  public setDependentPhone(dependentPhone) {
    this.dependentPhone = dependentPhone;

    return this;
  }

  public getDependentNote() {
    return this.dependentNote;
  }

  public setDependentNote(dependentNote) {
    this.dependentNote = dependentNote;

    return this;
  }

  public getDependentResident() {
    return this.dependentResident;
  }

  public setDependentResident(dependentResident) {
    this.dependentResident = dependentResident;

    return this;
  }
}
